import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 add_employee_to_tenant_module: { message: "idle" },
};

export const add_employee_to_tenant_module_Slice = createSlice({
 name: "add_employee_to_tenant_module",
 initialState,
 reducers: {
  success_add_employee_to_tenant_module: (state, action) => {
   state.add_employee_to_tenant_module = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_add_employee_to_tenant_module: (state, action) => {
   state.add_employee_to_tenant_module = { status: app_consts.FAIL, message: action.payload };
  },
  reset_add_employee_to_tenant_module: (state) => {
   state.add_employee_to_tenant_module = { status: app_consts.IDLE };
  },
  loading_add_employee_to_tenant_module: (state) => {
   state.add_employee_to_tenant_module = { status: app_consts.LOADING };
  },
 }
});

export const { success_add_employee_to_tenant_module, fail_add_employee_to_tenant_module, reset_add_employee_to_tenant_module, loading_add_employee_to_tenant_module } = add_employee_to_tenant_module_Slice.actions;

export default add_employee_to_tenant_module_Slice.reducer;